import { body } from '../../helpers/Print';

export default (theme, params, classes) => ({
    root: {
        height: '100%',
        position: 'relative',
        overflow: 'hidden',
        width: '100%',
        [`&:hover .${classes.track}`]: {
            opacity: 1,
        },
        [`.${body} &`]: {
            overflow: 'visible !important',
        },
    },
    dark: {
        [`& .${classes.track}`]: {
            background: 'rgba(255, 255, 255, 0.1)',
        },
        [`& .${classes.thumb}`]: {
            background: 'rgba(255, 255, 255, 0.4)',
        },
    },
    wrapper: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        overflow: 'hidden',
        zIndex: 0,
        [`.${body} &`]: {
            position: 'static !important',
            overflow: 'visible !important',
        },
    },
    content: {
        boxSizing: 'border-box',
        display: 'flex',
        flexDirection: 'column',
        minHeight: '100%',
        minWidth: '100%',
        position: 'relative',
    },
    contentReserve: {
        '& > .ScrollbarsCustom-Wrapper > .ScrollbarsCustom-Scroller > .ScrollbarsCustom-Content': {
            boxSizing: 'content-box !important',
            paddingRight: 'var(--sb-content-pad, 0px) !important',
        },
    },
    // Bottom gutter (e.g. so a floating button never permanently covers content).
    // Keeps border-box so the padding only produces scroll once content reaches
    // the bottom; short pages that fit the viewport stay scroll-free.
    contentReserveBottom: {
        '& > .ScrollbarsCustom-Wrapper > .ScrollbarsCustom-Scroller > .ScrollbarsCustom-Content': {
            paddingBottom: 'var(--sb-content-pad-bottom, 0px) !important',
        },
    },
    scrollArea: {
        position: 'absolute',
        top: 0,
        left: 0,
        bottom: 0,
        right: 0,
        overflow: 'scroll',
        [`.${body} &`]: {
            position: 'static !important',
            overflow: 'visible !important',
        },
    },
    track: {
        position: 'absolute',
        overflow: 'hidden',
        borderRadius: theme.spacing(0.5),
        background: 'rgba(0, 0, 0, 0.1)',
        userSelect: 'none',
        transitionProperty: 'transform, opacity',
        transitionDuration: '300ms',
        transitionTimingFunction: 'ease-in-out',
        opacity: 0,
        [`.${body} &`]: {
            display: 'none !important',
        },
    },
    trackHorizontal: {
        height: theme.spacing(1),
        width: '100%',
        bottom: 0,
        left: 0,
        transform: `translateY(${theme.spacing(1)})`,

        '.trackYVisible &': {
            width: `calc(100% - ${theme.spacing(1)})`,
        },
        '.trackXVisible:hover &': {
            transform: `translateY(0)`,
        },
        [`.${body} &`]: {
            display: 'none !important',
        },
    },
    trackVertical: {
        width: theme.spacing(1),
        height: '100%',
        top: 0,
        right: 0,
        transform: `translateX(${theme.spacing(1)})`,

        '.trackXVisible &': {
            height: `calc(100% - ${theme.spacing(1)})`,
        },
        '.trackYVisible:hover &': {
            transform: `translateX(0)`,
        },
        [`.${body} &`]: {
            display: 'none !important',
        },
    },
    thumb: {
        touchAction: 'none',
        cursor: 'pointer',
        borderRadius: theme.spacing(0.5),
        background: 'rgba(0, 0, 0, 0.4)',
        [`.${body} &`]: {
            display: 'none !important',
        },
    },
    thumbHorizontal: {},
    thumbVertical: {},
});
